import React from 'react';
import { Grid } from '@mui/material';
import { KpiCard } from 'dashboard/components/common';

/** Top four KPI tiles for the low-stock page: Out / Low / OK / Untracked. */
export default function LowStockKpiRow({ counts }) {
  return (
    <Grid container spacing='12px'>
      <Grid item xs={6} md={3}><KpiCard label='Out'       value={counts?.out       || 0} accent='#dc2626' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Low'       value={counts?.low       || 0} accent='#d97706' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='OK'        value={counts?.ok        || 0} accent='#16a34a' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Untracked' value={counts?.untracked || 0} /></Grid>
    </Grid>
  );
}
